import { useAuthContext } from 'components/context/AuthProvider'
import { SubscriptionStatus } from 'types'
import { isSubscriptionGated } from '../utils'
import { useCurrentSubscription } from './useSubscription'

const PAYMENT_ISSUE_STATUSES = new Set([
  SubscriptionStatus.PastDue,
  SubscriptionStatus.Incomplete,
  SubscriptionStatus.Unpaid,
])

export function useSubscriptionAccess() {
  const { user } = useAuthContext()
  const subscription = useCurrentSubscription()

  const hasPaymentIssue =
    isSubscriptionGated(user) && !!subscription && PAYMENT_ISSUE_STATUSES.has(subscription.status)

  return { hasPaymentIssue }
}
